import { apiFetch } from "@/lib/api";

export interface QboUnpaidInvoiceRow {
  qb_invoice_id: string;
  doc_number: string;
  customer_name: string | null;
  txn_date: string;
  due_date: string | null;
  total_amount: number;
  open_balance: number;
}

export interface QboUnpaidInvoicesResponse {
  rows: QboUnpaidInvoiceRow[];
  total_open_balance: number;
}

export interface UnshippedSalesOrderRow {
  order_number: string;
  customer_name: string | null;
  end_user_name: string | null;
  date_approved: string | null;
  ship_by_date: string | null;
  unshipped_value: number;
}

export interface UnshippedSalesOrdersResponse {
  rows: UnshippedSalesOrderRow[];
  row_count: number;
  total_unshipped_value: number;
}

export async function fetchAccountsReceivableUnpaidInvoices(): Promise<QboUnpaidInvoicesResponse> {
  return apiFetch<QboUnpaidInvoicesResponse>("/api/accounting/accounts-receivable/unpaid-invoices");
}

export async function fetchAccountsReceivableUnshippedOrders(): Promise<UnshippedSalesOrdersResponse> {
  return apiFetch<UnshippedSalesOrdersResponse>("/api/accounting/accounts-receivable/unshipped-orders");
}
